import { AsyncPipe, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, inject, computed, Component, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import { TuiDropdownOpen } from '@taiga-ui/core/directives/dropdown';
import { tuiSizeBigger } from '@taiga-ui/core/utils/miscellaneous';
import { AbstractTuiControl } from '@taiga-ui/legacy/classes';
import { TUI_TEXTFIELD_SIZE } from '@taiga-ui/legacy/directives';
import { PolymorpheusOutlet, PolymorpheusTemplate, PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { of } from 'rxjs';
import { tuiProvideOptions } from '@taiga-ui/cdk/utils/miscellaneous';

/**
 * @deprecated: drop in v5.0 use {@link TuiChevron}
 */
const TUI_ARROW_DEFAULT_OPTIONS = {
    iconSmall: '@tui.chevron-down',
    iconLarge: '@tui.chevron-down',
};
/**
 * @deprecated: drop in v5.0
 * Default parameters for arrow component
 */
const TUI_ARROW_OPTIONS = new InjectionToken(ngDevMode ? 'TUI_ARROW_OPTIONS' : '', {
    factory: () => TUI_ARROW_DEFAULT_OPTIONS,
});
function tuiArrowOptionsProvider(options) {
    return tuiProvideOptions(TUI_ARROW_OPTIONS, options, TUI_ARROW_DEFAULT_OPTIONS);
}

/**
 * @deprecated: drop in v5.0 use {@link TuiChevron}
 */
class TuiArrowComponent {
    constructor() {
        this.control = inject(AbstractTuiControl, { optional: true });
        this.textfieldSize = inject(TUI_TEXTFIELD_SIZE);
        this.options = inject(TUI_ARROW_OPTIONS);
        this.dropdownOpen = toSignal(inject(TuiDropdownOpen, { optional: true })?.tuiDropdownOpenChange || of(false));
        this.rotated = computed(() => this.dropdownOpen() || this.control.pseudoOpen?.());
    }
    get small() {
        return !tuiSizeBigger(this.textfieldSize.size);
    }
    get arrowIcon() {
        return !this.small ? this.options.iconLarge : this.options.iconSmall;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiArrowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: TuiArrowComponent, isStandalone: true, selector: "tui-arrow", host: { properties: { "class._rotated": "rotated()", "class._small": "small" } }, ngImport: i0, template: "<tui-icon\n    *polymorpheusOutlet=\"arrowIcon as src\"\n    [icon]=\"src\"\n/>\n", styles: [":host{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;display:block;cursor:pointer;pointer-events:none}:host._rotated{transform:rotate(180deg)}tui-icon{border-width:.25rem}\n"], dependencies: [{ kind: "directive", type: PolymorpheusOutlet, selector: "[polymorpheusOutlet]", inputs: ["polymorpheusOutlet", "polymorpheusOutletContext"] }, { kind: "component", type: TuiIcon, selector: "tui-icon", inputs: ["icon", "background"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiArrowComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'tui-arrow', imports: [AsyncPipe, NgIf, PolymorpheusOutlet, PolymorpheusTemplate, TuiIcon], changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class._rotated]': 'rotated()',
                        '[class._small]': 'small',
                    }, template: "<tui-icon\n    *polymorpheusOutlet=\"arrowIcon as src\"\n    [icon]=\"src\"\n/>\n", styles: [":host{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;display:block;cursor:pointer;pointer-events:none}:host._rotated{transform:rotate(180deg)}tui-icon{border-width:.25rem}\n"] }]
        }] });
const TUI_ARROW = new PolymorpheusComponent(TuiArrowComponent);

/**
 * @deprecated: drop in v5.0 use {@link TuiChevron}
 */
const TUI_ARROW_DEFAULT_MODE = {
    interactive: TUI_ARROW,
    disabled: TUI_ARROW,
};
/**
 * @deprecated: drop in v5.0 use {@link TuiChevron}
 */
const TUI_ARROW_MODE = new InjectionToken(ngDevMode ? 'TUI_ARROW_MODE' : '', {
    factory: () => TUI_ARROW_DEFAULT_MODE,
});
/**
 * @deprecated: drop in v5.0 use {@link TuiChevron}
 */
function tuiArrowModeProvider(options) {
    return tuiProvideOptions(TUI_ARROW_MODE, options, TUI_ARROW_DEFAULT_MODE);
}

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_ARROW, TUI_ARROW_DEFAULT_MODE, TUI_ARROW_DEFAULT_OPTIONS, TUI_ARROW_MODE, TUI_ARROW_OPTIONS, TuiArrowComponent, tuiArrowModeProvider, tuiArrowOptionsProvider };
